<template>
  <div class="mt-3">
    <div class="d-flex justify-content-between align-items-center pb-3">

      <div class="d-flex align-items-center justify-content-start">
        <span
            class="text-muted mr-4 mb-0 cursor-pointer"
            @click="$router.push({ name: 'CampaignAdmin' })"
            style="font-size: 18px"
          ><font-awesome-icon icon="chevron-left"/></span>

        <div class="d-flex flex-column">
          <h4 class="m-0">
            <strong>{{title}}</strong>
          </h4>

          <div v-if="campaign && (campaign.startDate || campaign.endDate) && !campaign.isDisabled" class="d-flex">
            <span class="text-muted" v-if="campaign.startDate">
              <template v-if="campaign.startDate">{{ campaign.startDate | formatDate('Do MMM, HH:mm') }}</template>
              <template v-else>-</template>
            </span>
            <span class="px-3" v-if="campaign.startDate && campaign.endDate">—</span>
            <span class="text-muted" v-if="campaign.endDate">
              <template v-if="campaign.endDate">{{ campaign.endDate | formatDate('Do MMM, HH:mm') }}</template>
              <template v-else>-</template>
            </span>
          </div>
          <div v-else-if="campaign && !campaign.isDisabled" class="text-muted">Loading...</div>
        </div>
      </div>

      <span class="d-flex justidy-content-end align-items-center">
        <b-spinner v-if="$apollo.loading" variant="primary" style="width: 1.2rem; height: 1.2rem;" class="mr-3" />
        <span
          class="status-label py-1 px-3"
          :style="{ backgroundColor: status.colour }"
        >{{status.label}}</span>
        <span
          v-if="campaign && !campaign.isDisabled"
          class="edit-campaign-label ml-2 py-1 px-3"
          v-b-modal.update-campaign-details-modal
        ><font-awesome-icon icon="pencil-alt"/></span>
      </span>
    </div>
    <b-card class="mt-2 wrapper-card" no-body>
      <div :class="{
        'campaign-stepper': true,
        'border-bottom': true,
        'd-flex': true,
        'justify-content-end': steps.length === 2,
        'align-items-stretch': true
      }">
        <div class="flex-fill p-3" style="color: #64748b" v-if="steps.length === 2">
          This is a Real Links built-in template campaign
        </div>
        <div
          v-for="({ key, title, routeName, icon, isDone }) in steps"
          :key="key"
          :class="{ 'w-25': true, 'p-3': true, 'cursor-pointer': true }"
          :style="step === key ? { color: brandingColour, borderBottom: `2px solid ${brandingColour}` } : {}"
          @click="$router.push({ name: routeName, params: { campaignID: campaign.id } })"
        >
          <font-awesome-icon class="mr-2" :icon="!campaign ? 'ellipsis-h' : icon"/>
          <span>{{title}}</span>
          <small v-if="isDone" class="text-success ml-2"><font-awesome-icon icon="check"/></small>
          <b-button
            v-if="campaign && step === 'engagement' && key === 'engagement' && !campaign.isDisabled"
            variant="primary"
            size="sm"
            class="float-right"
            style="border-radius: 3px; padding: 3px 8px; font-size: 12px; margin: -2px auto"
            @click.stop="$bvModal.show('update-engagement-details-modal')"
          >Settings</b-button>
        </div>
      </div>
      <div class="campaign-content">
        <slot></slot>
      </div>
    </b-card>
    <b-modal v-if="campaign" size="lg" id="update-campaign-details-modal" :title="$t('content-fetch.titles.update-campaign')" lazy hide-footer>
      <update-campaign-details :campaign="campaign" @updated="$bvModal.hide('update-campaign-details-modal')" />
    </b-modal>
    <b-modal v-if="campaign" size="lg" id="update-engagement-details-modal" title="Engagement Settings" lazy hide-footer>
      <update-engagement-details :campaign="campaign" @updated="$bvModal.hide('update-engagement-details-modal')" />
    </b-modal>
  </div>
</template>

<script>
import { campaignStatusMap } from '@/views/campaign-admin/Campaigns';
import UpdateCampaignDetails from '@/components/campaign-admin/update-campaign-details';
import UpdateEngagementDetails from '@/components/campaign-admin/update-engagement-details';
import { mapRoot } from '@src/mixins/root';

const steps = [ {
  key: 'jobs',
  icon: 'briefcase',
  title: 'Jobs',
  routeName: 'EditCampaignJobs',
}, {
  key: 'content',
  icon: 'share-alt',
  title: 'Content',
  routeName: 'EditCampaignContent',
}, {
  key: 'participants',
  icon: 'users',
  title: 'Participants',
  routeName: 'EditCampaignParticipants',
}, {
  key: 'gamification',
  icon: 'trophy',
  title: 'Gamification',
  routeName: 'EditCampaignGamification',
}, {
  key: 'engagement',
  icon: 'envelope',
  title: 'Engagement',
  routeName: 'EditCampaignEngagement',
},
// {
//   key: 'stages',
//   title: 'Stages',
//   routeName: 'EditCampaignStages',
// },
];

export default {
  name: 'CampaignAdminCampaigns',
  components: {
    UpdateCampaignDetails,
    UpdateEngagementDetails,
  },
  props: {
    campaign: {
      type: Object,
    },
    step: {
      type: String,
      validator: value => steps.map(({ key }) => key).includes(value),
    }
  },
  watch: {
    campaign() {
      if (this.campaign && this.$route && this.$route.query && this.$route.query.new) {
        console.log('RUNNING');
        setTimeout(() => {
          this.$bvModal.show('update-campaign-details-modal');
          this.$router.replace({ ...this.$route, query: null });
        }, 500);
      }
    }
  },
  computed: {
    ...mapRoot([ 'isSimplifiedCampaign', 'company' ]),
    brandingColour() {
      const { campaign } = this;
      return campaign && campaign.branding && campaign.branding.colour ? campaign.branding.colour : '#5f27cd';
    },
    title() {
      const { campaign } = this;
      return campaign && campaign.title ? campaign.title : 'Create Campaign';
    },
    status() {
      const { campaign } = this;
      return campaign && campaign.status ? campaignStatusMap[campaign.status] : campaignStatusMap['DRAFT'];
    },
    sitePreferences() {
      const { sitePreferences } = this.company || {};
      return sitePreferences || {};
    },
    steps() {
      const { doneSteps, sitePreferences, campaign } = this;
      const { preferences } = campaign || {};
      let { featuresEnabled } = sitePreferences || {};
      featuresEnabled = Array.isArray(featuresEnabled) ? featuresEnabled : [];
      return [ ...(!campaign || !campaign.isDisabled ? [ {
        key: 'jobs',
        title: this.$t('navigation.jobs'),
        icon: 'briefcase',
        isDone: doneSteps.includes('jobs'),
        routeName: 'EditCampaignJobs',
      }, {
        key: 'content',
        icon: 'share-alt',
        title: this.$t('campaign-admin.titles.content'),
        isDone: doneSteps.includes('content'),
        routeName: 'EditCampaignContent',
      }, {
        key: 'participants',
        icon: 'users',
        title: this.$t('campaign-admin.titles.participants'),
        isDone: doneSteps.includes('participants'),
        routeName: 'EditCampaignParticipants',
      } ] : []), {
        key: 'gamification',
        icon: 'trophy',
        title: this.$t('campaign-admin.titles.gamification'),
        isDone: doneSteps.includes('gamification'),
        routeName: 'EditCampaignGamification',
      }, {
        key: 'engagement',
        icon: 'envelope',
        title: this.$t('campaign-admin.titles.engagement'),
        isDone: doneSteps.includes('engagement'),
        routeName: featuresEnabled.includes('relative-message-dates') && preferences && preferences.hasRelativeDates ? 'EditCampaignEngagementRelativeDates' : 'EditCampaignEngagement',
      } ];
    },
    doneSteps() {
      const { campaign } = this;
      if (!campaign) {
        return [];
      }
      const { segment, dashboardJobs, contentShares, components, invitedUsers } = campaign || {};
      const { jobsConnection, usersConnection, scimUsersConnection } = segment || {};
      const doneSteps = [];
      if ((Array.isArray(dashboardJobs) && dashboardJobs.length > 0) || (jobsConnection && jobsConnection.where)) {
        doneSteps.push('jobs');
      }
      if (Array.isArray(contentShares) && contentShares.length > 0) {
        doneSteps.push('content');
      }
      if (invitedUsers || (usersConnection && usersConnection.where) || (scimUsersConnection && scimUsersConnection.where)) {
        doneSteps.push('participants');
      }
      const isGamification = Array.isArray(components) && components
        .find(({ leaderboard, collectiveGoal }) => leaderboard || collectiveGoal);
      const isEngagement = Array.isArray(components) && components
        .find(({ emailMessage, slackMessage, teamsMessage, pushMessage }) => emailMessage || slackMessage || teamsMessage || pushMessage);
      if (isGamification) {
        doneSteps.push('gamification');
      }
      if (isEngagement) {
        doneSteps.push('engagement');
      }
      return doneSteps;
    },
  }
};
</script>

<style lang="scss">
.admin-campaign-list {
  .wrapper-card {
    position: fixed;
    top: 120px;
    bottom: 25px;
    left: 25px;
    right: 25px;
  }
  .status-label {
    display: inline-block;
    color: #fff;
    border-radius: 3px;
  }
  .edit-campaign-label {
    display: inline-block;
    border-radius: 3px;
    background-color: #1d52ce;
    color: #fff;
    cursor: pointer;
    &:hover {
      background-color: #2f5ecb;
    }
    &:active {
      background-color: #134bce;
    }
  }
  .campaign-stepper {
    position: absolute;
    top: 0px;
    left: 0px;
    right: 0px;
    font-weight: bold;
  }
  .campaign-content {
    position: absolute;
    overflow-y: scroll;
    top: 57px;
    left: 0px;
    right: 0px;
    bottom: 0px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/campaign-admin/campaign-editor-frame.vue